import { Group } from "@mantine/core";
import { MyButton } from "../../../../UI/my-button/MyButton";
import { useColors } from "../../../../../hooks/colors/useColors";
import { bookingStore } from "../../../../config/store/bookingStore";
import { useTranslation } from "next-i18next";
import { Fragment } from "react";
import { useRouter } from "next/router";
import { useUser } from "../../../../../hooks/react-query/useUser";
import { isPhone } from "../../../../../constants/env";

export function StepperButtons(props: {
  finish?: () => void;
  disabled?: boolean;
  processing?: boolean;
  disableForward?: boolean;
}) {
  const { finish, disabled, processing, disableForward } = props;
  const {
    activeIndex,
    updateIndex,
    amount,
    setAmount,
    setPrepaymentStep,
    updateBookingForm,
    resetStepperFields,
    stepperFields,
  } = bookingStore((state) => state);
  const { t } = useTranslation("common");
  const router = useRouter();
  const { user } = useUser();

  function nextStep() {
    updateIndex(activeIndex < 5 ? activeIndex + 1 : activeIndex);
    if (window) {
      window.scrollTo(0, 0);
    }
  }

  function previousStep() {
    updateIndex(activeIndex > 0 ? activeIndex - 1 : activeIndex);
    if (window) {
      window.scrollTo(0, 0);
    }
  }
  const { colors } = useColors();

  async function cancel() {
    updateBookingForm(undefined);
    resetStepperFields();
    updateIndex(0);
    setAmount(0);
    setPrepaymentStep(false);
    await router.push("/user");
  }

  function confirmStep() {
    if (
      stepperFields.specialist &&
      stepperFields.specialist.online &&
      activeIndex === 2
    )
      return true;
    if (
      stepperFields.specialist &&
      !stepperFields.specialist.online &&
      activeIndex === 3
    )
      return true;
    return false;
  }

  return (
    <Fragment>
      <div
        className="flex justify-center items-center mt-8 mb-16 gap-8"
        style={{ flexDirection: isPhone ? "column" : undefined }}
      >
        {activeIndex !== 0 && (
          <MyButton
            size="xl"
            height="3rem"
            fontSize="1.5rem"
            variant="default"
            onClick={previousStep}
            color={colors.grayText}
            textColor={colors.primary}
            title={t("previous")}
          />
        )}
        {typeof finish !== "undefined" && (
          <MyButton
            size="xl"
            height="3rem"
            fontSize="1.5rem"
            variant="default"
            onClick={cancel}
            color={colors.danger}
            textColor={colors.danger}
            title={t("appointments.cancel")}
          />
        )}
        {!disableForward && (
          <Fragment>
            {!finish && (
              <MyButton
                size="xl"
                fontSize="1.5rem"
                height="3rem"
                loading={processing}
                disabled={disabled || processing}
                onClick={() => (!confirmStep() ? nextStep() : () => {})}
                color={colors.primary}
                title={`${t(
                  !confirmStep()
                    ? "next"
                    : amount > 0
                    ? "booking.submit-pay"
                    : "submit"
                )}${amount > 0 && confirmStep() ? " *" : ""}`}
              />
            )}
            {finish && (
              <MyButton
                size="xl"
                fontSize="1.5rem"
                height="3rem"
                loading={processing}
                disabled={disabled || processing}
                onClick={finish}
                color={colors.primary}
                title={`${t("submit")}${
                  amount > 0 && confirmStep() ? " *" : ""
                }`}
              />
            )}
          </Fragment>
        )}
        {!disableForward && !user && confirmStep() && (
          <MyButton
            size="xl"
            fontSize="1.5rem"
            height="3rem"
            loading={processing}
            disabled={disabled || processing}
            onClick={nextStep}
            color={colors.primary}
            title={`${t("next")}${amount > 0 && confirmStep() ? " *" : ""}`}
          />
        )}
      </div>
      {!user && activeIndex === 3 && (
        <div className="text-center my-6 text-orange-600">
          ! - <i>{t("appointments.register")}</i>
        </div>
      )}
      {amount > 0 && activeIndex === 3 && (
        <div className="text-center my-6">
          * - <i>{t("booking.payment-warning")}</i>
        </div>
      )}
    </Fragment>
  );
}
